const siderBar = {
  profile: "प्रोफाइल",
  history: "इतिहास",
  setting: "सेटिंग",
  promotion: "प्रमोशन",
};

export default siderBar;